import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup,Validators } from '@angular/forms';
import { PowerUserFormData, UserProfiles } from '../../../Models/user-profiles.model';
import { UserManagementService } from '../../../Services/user-management/user-management.service';
import { PowerUserRoles } from '../../../Models/user-profiles.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SessionService } from '../../../Services/session.service';
import { Injectable } from '@angular/core';
import { AssignRolesToPowerUserComponent } from '../assign-roles-to-power-user/assign-roles-to-power-user.component';
import { IPowerUser, IPowerUserRole, IPowerUserRoleList } from 'src/app/Models/User';
import { ConstantVars } from 'src/app/utils/constants/constants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PoweruserChangeStatusComponent } from '../poweruser-change-status/poweruser-change-status.component';
// import { ChangePowerUserStatusComponent } from '../change-power-user-status/change-power-user-status.component';

@Component({
  selector: 'app-edit-power-user',
  templateUrl: './edit-power-user.component.html',
  styleUrls: ['./edit-power-user.component.scss'],
})
export class EditPowerUserComponent implements OnInit {
  isAmailAddress: Boolean = false;
  educationalQualifications: any[];
  experienceType: any[];
  countryName: any[];
  countryCode: any[];
  State: any[];
  LanguageType: any[];
  powerUserStatus: any;
  currentExperience: string;
  setExperience: any;
  currentAddressId: number;
  settedCountry: string = '';
  modifyUserData: PowerUserFormData;
  DataUpdateFlag: boolean = false;
  currentLoggedInUser :string ;
  powerUserModifyForm = new FormGroup({
    firstName: new FormControl('', Validators.required),
    middleName: new FormControl(''),
    lastName: new FormControl('', Validators.required),
    countryCode1: new FormControl('', Validators.required),
    countryCode2: new FormControl(''),
    fullName: new FormControl({ value: '', disabled: true }),
    status: new FormControl(''),
    emailAddress: new FormControl(
      '',
      Validators.compose([Validators.required, Validators.email])
    ),
    primaryPhoneNumber: new FormControl(
      null,
      Validators.compose([
        Validators.required,
        Validators.pattern('^[0-9]{10}$'),
      ])
    ),
    secondaryPhoneNumber: new FormControl(''),
    addressLine1: new FormControl('', Validators.required),
    addressLine2: new FormControl(''),
    PostOffice: new FormControl(''),
    State: new FormControl('', Validators.required),
    City: new FormControl('', Validators.required),
    PINcode: new FormControl(null, Validators.required),
    Country: new FormControl('', Validators.required),
    educationQualification: new FormControl('', Validators.required),
    Experience: new FormControl('', Validators.required),
    Comment_Text: new FormControl(null),
    PrimaryLanguage: new FormControl('', Validators.required),
  });
  PowerUserID: string;

  constructor(
    private sessionService: SessionService,
    public toastr: ToastrService,
    private router: Router,
    public userService: UserManagementService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((param) => {
      this.currentLoggedInUser  = this.sessionService.getUser();

      this.PowerUserID = param.id
      this.getPowerUserById()


      const payload1={
        "PowerUserRoleID":null ,
        "SubjectID": null,
        "PowerUserID": param.id,
          }
      this.userService
        .getUserRoleList(payload1)
        .subscribe(
          (res:any) => {
            this.getPoweruserRoleByIdResponse(res?.PowerUserRoleList);


          },
          (error) => {
            console.log(error);
          }
        );
    });

    this.getEducationalQualification();
    this.getExperienceType();
    this.getCountryName();
    this.getCountryCode();
    this.getLanguage();


  }
  getPowerUserById(){
    const payload= {
      PowerUserID: this.PowerUserID,
      EmailAddressOnly:  null,
      NameOnly: null,
      SubjectID: null,
    }
    this.userService
      .getPowerUserById(payload)
      .subscribe(
        (res:any) => {

          this.setPowerUserData(res?.PowerUserList);
        },
        (error) => {
          console.log(error);
        }
      );
  }
  changePowerUserStatus(){
    const modalRef = this.modalService.open(PoweruserChangeStatusComponent, { size: 'lg', centered: true });
    modalRef.componentInstance.powerUserId = this.getpoweruser.Power_User_Id;
    modalRef.componentInstance.fromStatus = this.getpoweruser.Power_User_Status_Type_Code;
    modalRef.componentInstance.name = this.getpoweruser.Full_Name;
    // modalRef.componentInstance.startDate = '7/15/2025';
    modalRef.result.then(result => {
      if (result) {
        // result.toStatus, result.endDate, result.comments, etc.
        console.log('Form Result:', result);
        this.powerUserModifyForm.controls['fullName'].setValue(
          this.powerUserModifyForm.controls['firstName'].value +
            ' ' +
            this.powerUserModifyForm.controls['lastName'].value
        );
        const payload= {...this.powerUserModifyForm.getRawValue()}
        payload.status = result.toStatus;
        this.modifyUserOnClick(payload);
        // Handle the form data here!
      }
    });
  }

  selectedPowerUserRole: any;
  Power_User_Role_Data: IPowerUserRoleList[] = [];
  getPoweruserRoleByIdResponse(data: IPowerUserRoleList[]) {
    this.Power_User_Role_Data = data;
    this.selectedPowerUserRole = this.Power_User_Role_Data;
    console.log(this.selectedPowerUserRole, 'SelectedPowerUserRole');
  }

  SelectedPowerUserRole: string;
  clickPoweruseredit(value: IPowerUserRoleList, index: any) {
    //if(index==0){
    console.log(value);
    this.userService.getCodes('POWER_USER_ROLE_TYPE').subscribe(
      (res) => {
        this.getStatusTypeResponse(res);
        this.userService.powerUserRoleID = value.Power_User_Role_Id;
        this.PowerUserID = value.Power_User_ID;
        this.userService.Power_User_Role_Ind = value.Role_Updatable_Ind;
        this.userService.Screenurl = 'editPowerUser';
        this.router.navigate([`/EditPowerUserRole/${value.Power_User_ID}/${value?.Power_User_Role_Id}`]);
      },
      (error) => {
        // this.toastr.info()
      }
    );
    // }
    // else{
    //   console.log('test1')
    // }
  }

  getStatusTypeResponse(data: any) {
    var tempRoleStatusType: any[] = [];

    data.forEach((element: { Code: any; Name: any }) => {
      tempRoleStatusType.push({
        Code: element.Code,
        Name: element.Name,
      });
    });

    this.userService.powerUserStatusTypes = tempRoleStatusType;
  }
  getLanguage() {
    this.userService.getCodes('Language_Type').subscribe(
      (res) => {
        this.getLanguageTypeResponse(res);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getLanguageTypeResponse(data: any) {
    var tempLanguageType: any[] = [];

    data.forEach((element: { Code: any; Name: any }) => {
      tempLanguageType.push({
        Code: element.Code,
        Name: element.Name,
      });
    });

    this.LanguageType = tempLanguageType;
  }
  getUserState(country:string ,userstate:string='') {
    this.userService.getStates(country).subscribe(
      (res:any) => {

        this.State = res;
        if(userstate){

          this.powerUserModifyForm.controls['State'].setValue(
            userstate
          );
          console.log(this.powerUserModifyForm.value);

        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  phonenumber1flag: boolean = false;
  phonenumber2flag: boolean = false;
  countrynumber1flag: boolean = false;
  countrynumber2flag: boolean = false;
  selectcountrycode() {
    if (!this.powerUserModifyForm.controls['primaryPhoneNumber'].value) {
      if (this.powerUserModifyForm.controls['countryCode1'].value == ' ') {
        this.phonenumber1flag = false;
      } else {
        this.phonenumber1flag = true;
      }
    }

    if (this.powerUserModifyForm.controls['countryCode1'].value) {
      this.countrynumber1flag = false;
    } else {
      this.countrynumber1flag = true;
    }
    this.Editformvalidation();
  }
  selectcountrycode1() {
    if (!this.powerUserModifyForm.controls['secondaryPhoneNumber'].value) {
      if (this.powerUserModifyForm.controls['countryCode2'].value == ' ') {
        this.phonenumber2flag = false;
      } else {
        this.phonenumber2flag = true;
      }
    }

    if (this.powerUserModifyForm.controls['countryCode2'].value) {
      this.countrynumber2flag = false;
    } else {
      this.countrynumber2flag = true;
    }
    this.Editformvalidation();
  }
  selectphonemnumber1() {
    if (!this.powerUserModifyForm.controls['countryCode1'].value) {
      this.countrynumber1flag = true;
    }
    if (this.powerUserModifyForm.controls['primaryPhoneNumber'].value) {
      this.phonenumber1flag = false;
    } else {
      this.phonenumber1flag = true;
    }
    this.Editformvalidation();
  }
  selectphonemnumber2() {
    if (!this.powerUserModifyForm.controls['countryCode2'].value) {
      this.countrynumber2flag = true;
    }
    if (this.powerUserModifyForm.controls['secondaryPhoneNumber'].value) {
      this.phonenumber2flag = false;
    } else {
      if (this.powerUserModifyForm.controls['countryCode2'].value == ' ') {
        this.phonenumber2flag = false;
      } else {
        this.phonenumber2flag = true;
      }
      //this.phonenumber2flag=true;
    }
    this.Editformvalidation();
  }



  getpoweruser: IPowerUser;
  RoleInd: string;
  setPowerUserData(data: IPowerUser[]) {
    console.log('DATA: ', data);

    this.getpoweruser = data[0];
    this.getUserState(data[0].Country_Code, data[0].State_Code);
    this.powerUserModifyForm.controls['firstName'].setValue(data[0].First_Name);
    this.powerUserModifyForm.controls['lastName'].setValue(data[0].Last_Name);
    this.powerUserModifyForm.controls['middleName'].setValue(
      data[0].Middle_Name
    );
    this.powerUserModifyForm.controls['fullName'].setValue(
      data[0].First_Name + ' ' + data[0].Last_Name
    );
    this.powerUserModifyForm.controls['emailAddress'].setValue(data[0].Email_Address);
    this.powerUserModifyForm.controls['status'].setValue(
      data[0].Power_User_Status_Type_Code
    );
    this.powerUserModifyForm.controls['primaryPhoneNumber'].setValue(
      data[0].Primary_Phone_Number
    );
    this.powerUserModifyForm.controls['PrimaryLanguage'].setValue(
      data[0].Mother_Tongue_Language_Type_Code
    );
    this.powerUserModifyForm.controls['educationQualification'].setValue(
      data[0].Education_Type_Code
    );
    this.powerUserModifyForm.controls['Experience'].setValue(
      data[0].Experience_Type_Code
    );
    this.powerUserModifyForm.controls['Country'].setValue(
      data[0].Country_Code
    );
    this.powerUserModifyForm.controls['addressLine1'].setValue(
      data[0].Address_Line_1
    );
    this.powerUserModifyForm.controls['addressLine2'].setValue(
      data[0].Address_Line_2
    );
    this.powerUserModifyForm.controls['PostOffice'].setValue(
      data[0].Address_Line_3
    );

    //this.powerUserModifyForm.controls['addressLine2'].setValue(data[0].Address.AddressLine2 + " " + data[0].Address.AddressLine3)
    this.powerUserModifyForm.controls['countryCode1'].setValue(
      data[0].Primary_Phone_Country_Code
    );
    this.powerUserModifyForm.controls['countryCode2'].setValue(
      data[0].Secondary_Phone_Country_Code
    );
    this.powerUserModifyForm.controls['PINcode'].setValue(
      data[0].Postal_Code
    );
    this.powerUserModifyForm.controls['State'].setValue(
      data[0].State_Code
    );
    this.powerUserModifyForm.controls['City'].setValue(
      data[0].City_Name
    );
    this.RoleInd = data[0].Activate_Role_Assign_Ind;
    this.currentExperience = data[0].Experience_Type_Code;
    this.currentAddressId = data[0].Address_Id;
    //this.setFormCountry(data[0].Address.CountryCode)

    if (
      data[0].Secondary_Phone_Number != null &&
      data[0].Secondary_Phone_Number != '' &&
      data[0].Secondary_Phone_Number != 'undefined'
    ) {
      this.powerUserModifyForm.controls['secondaryPhoneNumber'].setValue(
        data[0].Secondary_Phone_Number
      );
    }
    if (
      data[0].Secondary_Phone_Country_Code != null &&
      data[0].Secondary_Phone_Country_Code != '' &&
      data[0].Secondary_Phone_Country_Code != 'undefined'
    ) {
      this.powerUserModifyForm.controls['countryCode2'].setValue(
        data[0].Secondary_Phone_Country_Code
      );
    }
    if (
      data[0].Address_Line_3 != null &&
      data[0].Address_Line_3 != '' &&
      data[0].Address_Line_3 != 'undefined' &&
      data[0].Address_Line_2 != null &&
      data[0].Address_Line_2 != '' &&
      data[0].Address_Line_2 != 'undefined'
    ) {

      this.powerUserModifyForm.controls['addressLine2'].setValue(
        data[0].Address_Line_2 + ' ' + data[0].Address_Line_3
      );
    }
    if (
      data[0].Address_Line_2 != null &&
      data[0].Address_Line_2 != '' &&
      data[0].Address_Line_2 != 'undefined'
    ) {
      this.powerUserModifyForm.controls['addressLine2'].setValue(
        data[0].Address_Line_2
      );
    }
    if (
      data[0].Experience_Description_Text != null &&
      data[0].Experience_Description_Text != '' &&
      data[0].Experience_Description_Text != 'undefined'
    ) {
      this.powerUserModifyForm.controls['Comment_Text'].setValue(
        data[0].Experience_Description_Text
      );
    }


    //this.powerUserModifyForm.controls['Comment_Text'].setValue(data[0].ExperienceDescription)
  }


  onSelectExperience(event: any) {
    this.setExperience = event;
  }

  ClickDeactivate() {
    this.powerUserModifyForm.controls['fullName'].setValue(
      this.powerUserModifyForm.controls['firstName'].value +
        ' ' +
        this.powerUserModifyForm.controls['lastName'].value
    );

    this.OnClickDeactivate(this.powerUserModifyForm.value);
  }

  ClickActivation() {
    this.powerUserModifyForm.controls['fullName'].setValue(
      this.powerUserModifyForm.controls['firstName'].value +
        ' ' +
        this.powerUserModifyForm.controls['lastName'].value
    );

    this.OnClickActivation(this.powerUserModifyForm.value);
  }

  OnClickActivation(data: any) {
    var tempModifyUser: PowerUserFormData;

    tempModifyUser = {
      PowerUserId: this.PowerUserID,
      LastName: data.lastName,
      MiddleName: data.middleName,
      FirstName: data.firstName,
      Email: data.emailAddress,
      PrimaryPhoneCountryCode: data.countryCode1,
      PrimaryPhoneNumber: data.primaryPhoneNumber,
      SecondaryPhoneCountryCode: data.countryCode2,
      SecondaryPhoneNumber: data.secondaryPhoneNumber,
      PrimaryLanguage: data.PrimaryLanguage,
      EducationType: data.educationQualification,
      ExperienceType: data.Experience,
      UserStatusType: 'Active',
      LoggedInUser: this.sessionService.getUser(),
      Address: {
        AddressId: this.currentAddressId,
        AddressLine1: data.addressLine1,
        AddressLine2: data.addressLine2,
        AddressLine3: '',
        CityName: data.City,
        StateCode: data.State,
        CountryCode: data.Country,
        PostalCode: data.PINcode,
      },
      CreatedBy: this.sessionService.getUser(),
      CreationDate: '9/25/2021 12:00:00 AM',
      ExperienceDescription: data.Comment_Text,
    };
    console.log(tempModifyUser);
    this.modifyUserData = tempModifyUser;
    this.userService.modifyUser(this.modifyUserData).subscribe(
      (res) => {
        console.log(res);
        this.toastr.success('Success!', 'Power User Activated!');
        this.router.navigate(['User/Poweruserlist']);
        console.log(res);
      },
      (error) => {
        this.toastr.error(error.error.Message);
        console.log(error.Message);
      }
    );
  }

  OnClickDeactivate(data: any) {
    var tempModifyUser: PowerUserFormData;

    tempModifyUser = {
      PowerUserId: this.PowerUserID,
      LastName: data.lastName,
      MiddleName: data.middleName,
      FirstName: data.firstName,
      Email: data.emailAddress,
      PrimaryPhoneCountryCode: data.countryCode1,
      PrimaryPhoneNumber: data.primaryPhoneNumber,
      SecondaryPhoneCountryCode: data.countryCode2,
      SecondaryPhoneNumber: data.secondaryPhoneNumber,
      EducationType: data.educationQualification,
      ExperienceType: data.Experience,
      PrimaryLanguage: data.PrimaryLanguage,
      UserStatusType: 'Disabled',
      LoggedInUser: this.sessionService.getUser(),
      Address: {
        AddressId: this.currentAddressId,
        AddressLine1: data.addressLine1,
        AddressLine2: data.addressLine2,
        AddressLine3: '',
        CityName: data.City,
        StateCode: data.State,
        CountryCode: data.Country,
        PostalCode: data.PINcode,
      },
      CreatedBy: this.sessionService.getUser(),
      CreationDate: '9/25/2021 12:00:00 AM',
      ExperienceDescription: data.Comment_Text,
    };
    console.log(tempModifyUser);
    this.modifyUserData = tempModifyUser;
    this.userService.modifyUser(this.modifyUserData).subscribe(
      (res) => {
        console.log(res);
        this.toastr.success('Success!', 'Power User Deactivated!');
        this.router.navigate(['User/Poweruserlist']);
        console.log(res);
      },
      (error) => {
        this.toastr.error(error.error.Message);
        console.log(error.Message);
      }
    );
  }

  getEmailErrorMessage() {
    this.isAmailAddress = true;
  }

  saveOnClick() {


    this.powerUserModifyForm.controls['fullName'].setValue(
      this.powerUserModifyForm.controls['firstName'].value +
        ' ' +
        this.powerUserModifyForm.controls['lastName'].value
    );

    this.modifyUserOnClick(this.powerUserModifyForm.value);
  }

  modifyUserOnClick(data: any) {
    var tempModifyUser: PowerUserFormData;

    tempModifyUser = {
      PowerUserId: this.PowerUserID,
      LastName: data.lastName,
      MiddleName: data.middleName,
      FirstName: data.firstName,
      Email: data.emailAddress,
      PrimaryPhoneCountryCode: data.countryCode1,
      PrimaryPhoneNumber: data.primaryPhoneNumber,
      SecondaryPhoneCountryCode: data.countryCode2,
      SecondaryPhoneNumber: data.secondaryPhoneNumber,
      EducationType: data.educationQualification,
      PrimaryLanguage: data.PrimaryLanguage,
      ExperienceType: data.Experience,
      // UserStatusType: "New",
      UserStatusType: data.status,
      LoggedInUser: this.sessionService.getUser(),
      Address: {
        AddressId: this.currentAddressId,
        AddressLine1: data.addressLine1,
        AddressLine2: data.addressLine2,
        AddressLine3: data.PostOffice,
        CityName: data.City,
        StateCode: data.State,
        CountryCode: data.Country,
        PostalCode: data.PINcode,
      },
      CreatedBy: this.sessionService.getUser(),
      CreationDate: '9/25/2021 12:00:00 AM',
      ExperienceDescription: data.Comment_Text,
    };
    this.modifyUserData = tempModifyUser;

    this.userService.modifyUser(this.modifyUserData).subscribe(
      (res) => {
        console.log(res);
        this.toastr.success('Success!', 'Power User Updated!');
        this.getPowerUserById()
        // this.router.navigate(['User/Poweruserlist']);
        console.log(res);
      },
      (error) => {
        //this.toastr.error('ERROR!', 'A power user with the same email exists!');
        this.toastr.error(error.error.Message);
        console.log(error.Message);
      }
    );
  }

  Cancelbutton() {
    this.Editformvalidation();
    if (this.DataUpdateFlag) {
      this.AlertCancelpopup();
    } else {
      this.DiscardChanges();
    }

    //this.router.navigate(['User/Poweruserlist']);
  }
  cancelalertflag: boolean;
  AlertCancelpopup() {
    this.cancelalertflag = !this.cancelalertflag;
  }

  DiscardChanges() {
    this.AlertCancelpopup();
    this.router.navigate(['User/Poweruserlist']);
  }
  OnClickChangeStatus() {
    //this.router.navigate(['/changePowerUserStatus']);
    // const dialogRef = this.dialog.open(ChangePowerUserStatusComponent, {
    //   height: '700px',
    //   width: '600px',
    //   disableClose: true,
    // });
  }

  Closepopup(data: any) {
    if (this.Assignroletouser) {
      this.onClickAssignRoleButton();
    }
  }

  Assignroletouser: boolean = false;
  onClickAssignRoleButton() {
    // this.router.navigate(['/assignRolesToPowerUser']);
    this.userService.userName =
      this.powerUserModifyForm.controls['fullName'].value;
    this.userService.userStatus =
      this.powerUserModifyForm.controls['status'].value;
    this.Assignroletouser = !this.Assignroletouser;
    // const dialogRef = this.dialog.open(AssignRolesToPowerUserComponent, {
    //   height: '980px',
    //   width: '800px',
    //   disableClose: true,

    // });
  }

  getExperienceType() {
    this.userService.getCodes('EXPERIENCE_TYPE').subscribe(
      (res) => {
        this.getExperienceTypeResponse(res);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getExperienceTypeResponse(data: any) {
    var tempExperienceType: any[] = [];

    data.forEach((element: { Code: any; Name: any }) => {
      tempExperienceType.push({
        Code: element.Code,
        Name: element.Name,
      });
    });

    this.experienceType = tempExperienceType;
  }

  getEducationalQualification() {
    this.userService.getCodes('EDUCATION_TYPE').subscribe(
      (res) => {
        this.getEducationalQualificationResponse(res);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getEducationalQualificationResponse(data: any) {
    var tempEducationalQualifications: any[] = [];

    data.forEach((element: { Name: any; Code: any }) => {
      tempEducationalQualifications.push({
        Name: element.Name,
        Code: element.Code,
      });
    });

    this.educationalQualifications = tempEducationalQualifications;
  }

  async getCountryName() {
    this.userService.getCodes('COUNTRY').subscribe(
      (res) => {
        this.getCountryNameResponse(res);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getCountryNameResponse(data: any) {
    var tempCountryName: any[] = [];

    data.forEach((element: { Code: any; Name: any }) => {
      tempCountryName.push({
        Code: element.Code,
        Name: element.Name,
      });
    });

    this.countryName = tempCountryName;
  }

  getCountryCode() {
    this.userService.getCodes('PHONE_COUNTRY_CODE').subscribe(
      (res) => {
        this.getCountryCodeResponse(res);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getCountryCodeResponse(data: any) {
    var tempCountryCode: any[] = [];

    data.forEach((element: { Code: any; Name: any }) => {
      tempCountryCode.push({
        Code: element.Code,
        Name: element.Name,
      });
    });
    this.countryCode = tempCountryCode;
  }

  onCountryChange(event: any){
    const country = event.target.value;
    this.powerUserModifyForm.controls['State'].setValue(null)
    this.getUserState(country)
    this.Editformvalidation()

  }
  Editformvalidation() {
    if (this.powerUserModifyForm.valid) {

      var firstName = this.powerUserModifyForm.controls['firstName'].value;
      var middleName = this.powerUserModifyForm.controls['middleName'].value;
      var lastName = this.powerUserModifyForm.controls['lastName'].value;
      var countryCode1 =
        this.powerUserModifyForm.controls['countryCode1'].value;
      var countryCode2 =
        this.powerUserModifyForm.controls['countryCode2'].value;
      var fullName = this.powerUserModifyForm.controls['fullName'].value;
      var status = this.powerUserModifyForm.controls['status'].value;
      var emailAddress =
        this.powerUserModifyForm.controls['emailAddress'].value;
      var primaryPhoneNumber =
        this.powerUserModifyForm.controls['primaryPhoneNumber'].value;
      var secondaryPhoneNumber =
        this.powerUserModifyForm.controls['secondaryPhoneNumber'].value;
      var addressLine1 =
        this.powerUserModifyForm.controls['addressLine1'].value;
      var addressLine2 =
        this.powerUserModifyForm.controls['addressLine2'].value;
      var PostOffice = this.powerUserModifyForm.controls['PostOffice'].value;
      var State = this.powerUserModifyForm.controls['State'].value;
      var City = this.powerUserModifyForm.controls['City'].value;
      var PINcode = this.powerUserModifyForm.controls['PINcode'].value;
      var Country = this.powerUserModifyForm.controls['Country'].value;
      var educationQualification =
        this.powerUserModifyForm.controls['educationQualification'].value;
      var primarylanguage =
        this.powerUserModifyForm.controls['PrimaryLanguage'].value;
      var Experience = this.powerUserModifyForm.controls['Experience'].value;
      var Comment_Text =
        this.powerUserModifyForm.controls['Comment_Text'].value;

      if (firstName != this.getpoweruser.First_Name) this.DataUpdateFlag = true;
      else if (primarylanguage != this.getpoweruser.Mother_Tongue_Language_Type_Code)
        this.DataUpdateFlag = true;
      else if (middleName != this.getpoweruser.Middle_Name)
        this.DataUpdateFlag = true;
      else if (lastName != this.getpoweruser.Last_Name)
        this.DataUpdateFlag = true;
      else if (countryCode1 != this.getpoweruser.Primary_Phone_Country_Code)
        this.DataUpdateFlag = true;
      else if (countryCode2 != this.getpoweruser.Secondary_Phone_Country_Code)
        this.DataUpdateFlag = true;
      else if (status != this.getpoweruser.Power_User_Status_Type_Code)
        this.DataUpdateFlag = true;
      else if (emailAddress != this.getpoweruser.Email_Address)
        this.DataUpdateFlag = true;
      else if (primaryPhoneNumber != this.getpoweruser.Primary_Phone_Number)
        this.DataUpdateFlag = true;
      else if (secondaryPhoneNumber != this.getpoweruser.Secondary_Phone_Number)
        this.DataUpdateFlag = true;
      else if (addressLine1 != this.getpoweruser.Address_Line_1)
        this.DataUpdateFlag = true;
      else if (addressLine2 != this.getpoweruser.Address_Line_2)
        this.DataUpdateFlag = true;
      // else if(PostOffice!=this.getpoweruser[0].Answer_Selection_Type_Code)
      // this.DataUpdateFlag=true;
      else if (State != this.getpoweruser.State_Code)
        this.DataUpdateFlag = true;
      else if (City != this.getpoweruser.City_Name)
        this.DataUpdateFlag = true;
      else if (PINcode != this.getpoweruser.Postal_Code)
        this.DataUpdateFlag = true;
      else if (Country != this.getpoweruser.Country_Code)
        this.DataUpdateFlag = true;
      else if (educationQualification != this.getpoweruser.Education_Type_Code)
        this.DataUpdateFlag = true;
      else if (Experience != this.getpoweruser.Experience_Type_Code)
        this.DataUpdateFlag = true;
      else if (Comment_Text != this.getpoweruser.Experience_Description_Text)
        this.DataUpdateFlag = true;
      else if (PostOffice != this.getpoweruser.Address_Line_3)
        this.DataUpdateFlag = true;
      else this.DataUpdateFlag = false;
    }
  }

  passwordflag: boolean;
  Clickpassword() {
    //this.passwordflag=!this.passwordflag;
    //this.router.navigate(['User/Setpassword']);

    this.OnClickPasswordActivation(this.powerUserModifyForm.value);
  }

  OnClickPasswordActivation(data: any) {
    var token = this.sessionService.getToken();
    var emailAddress = this.powerUserModifyForm.controls['emailAddress'].value;
    var UserId = this.PowerUserID;

    this.userService
      .SendEmailReSetPassword({
        Email: emailAddress,
        Token: token,
        PowerUserID: UserId,
      })
      .subscribe(
        (res) => {
          console.log(res);
          this.toastr.success('Success!', 'Email Sent Successfully!');
          this.router.navigate(['User/Poweruserlist']);
        },
        (error) => {
          //this.toastr.error('ERROR!', 'A power user with the same email exists!');
          this.toastr.error('Email could not be send', "",{
            timeOut: ConstantVars.ToastErrorTimeout
          });
          console.log(error.Message);
        }
      );
  }

  // passwordflag:boolean
  Clickrestpassword() {
    //this.passwordflag=!this.passwordflag;
    //this.router.navigate(['User/Setpassword']);

    this.OnClickResetPassword(this.powerUserModifyForm.value);
  }

  OnClickResetPassword(data: any) {
    var token = this.sessionService.getToken();
    var emailAddress = this.powerUserModifyForm.controls['emailAddress'].value;
    var UserId = this.PowerUserID;

    this.userService
      .SendEmailReSetPassword({
        Email: emailAddress,
        Token: token,
        PowerUserID: UserId,
      })
      .subscribe(
        (res) => {
          console.log(res);
          this.toastr.success('Success!', 'Email has been sent!');
          this.router.navigate(['User/Poweruserlist']);
          console.log(res);
        },
        (error) => {
          //this.toastr.error('ERROR!', 'A power user with the same email exists!');
          this.toastr.error(error.error.Message);
          console.log(error.Message);
        }
      );
  }
}
